import React, { useEffect, useRef } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import SkipLink from '../SkipLink/SkipLink';
import styles from './Layout.module.css';

/* A fresh Layout mounts per route (Routes is keyed by pathname), so
   moving focus to <main> on mount announces the new page to screen
   readers and starts keyboard tabbing from the content — except on the
   very first load (don't steal focus from the top of the document) and
   when the URL carries an in-page hash (honour the anchor). */
let firstLoad = true;

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (firstLoad) {
      firstLoad = false;
      return;
    }
    if (window.location.hash) return;
    mainRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <div className={styles.layout}>
      <SkipLink />
      <Header />
      <main
        id="main-content"
        ref={mainRef}
        tabIndex={-1}
        className={styles.mainContent}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
